<template>
  <div>
    <v-card height="110px" class="elevation-4">
      <v-col>
        <img alt="Vue Material Admin" class="pr-5" src="../../assets/gfi.png" style="max-height: 65px">
      </v-col>
    </v-card>
    <v-container>
      <v-row style="margin-top:150px">
        <v-col cols="12" >
          <v-container fluid>
            <v-layout  justify-center>
              <v-flex lg4 md4 sm8 xs12>
                <ValidationObserver ref="obs" v-slot="{ invalid, validated, passes, validate }">
                  <v-card>
                    <v-card-text>
                      <!--<div class="layout column align-center">
                        <img alt="Vue Material Admin" src="../../assets/bsn.png" >
                      </div>-->
                      <v-form class="pt-3">
                        <ValidationProvider :rules="{ required, max:20, regex: /^[A-Za-z\s@'/]+$/ }" name="username" v-slot="{ errors, valid, failedRules }">
                          <v-text-field append-icon="mdi-account"
                                        :label="$t('msg.username_label')" name="username"
                                        type="text"
                                        autocomplete="new-password"
                                        :error-messages="$translatedErrorMessages(failedRules,'username')"
                                        :success="valid"
                                        id="username" v-model="username"
                                        v-on:keyup.enter="passes(login)"></v-text-field>
                        </ValidationProvider>
                        <ValidationProvider :rules="{ required, max:20, regex: /^[A-Za-z\s@#$%^&+=]+$/ }" name="password" v-slot="{ errors, valid, failedRules }">
                          <v-text-field append-icon="mdi-lock" :label="$t('msg.password_label')"
                                        name="password"
                                        type="password"
                                        autocomplete="new-password"
                                        :error-messages="$translatedErrorMessages(failedRules,'password')"
                                        :success="valid"
                                        id="password" v-model="password"
                                        v-on:keyup.enter="passes(login)"></v-text-field>
                        </ValidationProvider>
                        <v-spacer></v-spacer>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-layout justify-center>
                      <v-btn block :loading="loading" @click="passes(login)" color="primary" dark>
                        {{$t('msg.login_button')}}
                      </v-btn>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </ValidationObserver>
              </v-flex>
            </v-layout>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <v-footer absolute color="primary" dark>
      <div class="font-weight-regular">©2020 Global Psytech Sdn. Bhd.</div>
    </v-footer>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
export default {
  name: 'Login',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data () {
    return {
      snackbar: false,
      loading: false,
      username: '',
      password: '',
      type: 'ROLE_HGP_STANDARD_DASHBOARD',
      hidePassword: true,
      result: '',
      showResult: false,
      invalidUserCredentials: false,
      loginModelStatus: false,
      required: ''
    }
  },
  methods: {
    login: function () {
      this.$router.push('/dashboard')
    }
  }
}
</script>

<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }

  .logoStyle{
    width: 250px;
    height: 90px;
  }
  .eInsightsLogoStyle{
    width: 250px;
    height: 80px;
  }
  .v-application a{
    color: #000;
    text-decoration: none;
    opacity: .5;
  }
  .v-application a:hover{
    opacity: 1;
    text-decoration: underline;
  }
</style>
